module.exports = __webpack_public_path__ + "assets/xiangxi.5b12e9d3d70eb84bd71502be969b7a61.png";